import type { ReactNode } from "react";
import U2000RequireRole from "../u2000Core/components/controls/U2000RequireRole";
import U3142, { U3142ROLES } from "./U3142";
import U3142LotList from "./components/U3142LotList";
import U3142LotForm from "./components/U3142LotForm";

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U3142Routes: RouteObject[] = [
  {
    path: "U3142",
    element: <U2000RequireRole allowedRoles={[U3142ROLES.READ]} />,
    children: [
      {
        path: "",
        element: <U3142 />,
        children: [
          { index: true, element: <U3142LotList /> },
          { path: ":id", element: <U3142LotForm /> },
        ],
      },
    ],
  },
];

export default U3142Routes;
